// src/contexts/MenuContext.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

interface MenuContextType {
  selectedMenuItem: string;
  setSelectedMenuItem: (_item: string) => void;
  isSettingFromSidebar: boolean;
  setIsSettingFromSidebar: (_value: boolean) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const MenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedMenuItem, setSelectedMenuItem] = useState<string>("");
  const [isSettingFromSidebar, setIsSettingFromSidebar] = useState<boolean>(false);

  return (
    <MenuContext.Provider value={{
      selectedMenuItem,
      setSelectedMenuItem,
      isSettingFromSidebar,
      setIsSettingFromSidebar
    }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => {
  const context = useContext(MenuContext);
  if (context === undefined) {
    throw new Error("useMenu must be used within a MenuProvider");
  }
  return context;
};

